import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../components/sub-component/Button";
import Emoji from "../../../assets/icons/onboarding/Emoji.svg";
import Checkbox from "../../../components/sub-component/Checkbox";
import { patchAssessment } from "../../../redux/thunks/Assessment";
import ProcessingIndicator from "../../../components/common/ProcessingIndicator";
import { ReactComponent as ShieldIcon } from "../../../assets/icons/candidate-assessment/shield.svg";
import { ReactComponent as TestFuseWatermarkIcon } from "../../../assets/icons/candidate-assessment/Watermark.svg";

export default function MonitoringConsent({
  assessment,
  submitMonitoringConsent,
  setSubmitMonitoringConsent,
}) {
  const params = useParams();
  const dispatch = useDispatch();

  const handlePatchAssessment = (data) => {
    dispatch(patchAssessment({ id: params.id, data }));
  };

  return (
    <div className="candidate-assessment-flow-container">
      <div
        className="candidate-assment-flow-wrapper"
        style={{ height: "80vh" }}
      >
        <div
          className="d-flex flex-column align-items-center"
          style={{
            maxWidth: "684px",
            gap: "24px",
            borderRadius: "24px",
            backgroundColor: "white",
          }}
        >
          <div
            className="d-flex flex-column align-items-center"
            style={{
              padding: "24px",
              gap: "24px",
            }}
          >
            <ShieldIcon />
            <span className={`headline-4 dark-100 text-center`}>
              Test Integrity Monitoring
            </span>
            <div
              className="d-flex flex-column align-items-start"
              style={{ gap: "24px" }}
            >
              <span className="body-2 dark-50 text-start">
                To ensure a fair testing environment, this assessment uses an
                automated proctoring system.
              </span>
              <span className="body-2 dark-50 text-start">
                By proceeding, you consent to:
              </span>
              <li className="body-2 dark-50 text-start">
                Continuous Webcam Monitoring: Our system will capture periodic
                screenshots from your webcam (e.g., every 15 seconds) throughout
                this assessment to detect and prevent cheating.
              </li>
              <span className="body-2 dark-50 text-start">
                This monitoring will begin now. For full details, please review
                our{" "}
                <a
                  href={`${window._env_.TF_LANDING_SITE_URL}/biometric-information-policy`}
                  rel="noopener noreferrer"
                  target="_blank"
                  className=" dark-100"
                >
                  Biometric Information Policy.
                </a>
              </span>
              <div className="w-100 d-flex flex-row" style={{ gap: "12px" }}>
                <div>
                  <Checkbox
                    primary
                    onChange={() => {
                      setSubmitMonitoringConsent(true);
                    }}
                    checked={submitMonitoringConsent}
                  />
                </div>
                <span className="body-2 text-start">
                  I agree to the test integrity monitoring.
                </span>
              </div>
            </div>
          </div>
          <div
            className="login-input-group w-100 d-flex align-items-end justify-content-end"
            style={{ padding: "24px 0px", borderTop: "1px solid #ECEDF1" }}
          >
            <Button
              btn="ragular-btn"
              varrient="primary"
              title={"Start Assessment"}
              style={{
                width: "max-content",
                height: "40px",
                marginRight: "24px",
              }}
              disabled={!submitMonitoringConsent}
              onClick={() => {
                handlePatchAssessment({
                  has_submitted_integrity_consent: true,
                  has_submitted_video_resp_consent:
                    assessment?.has_submitted_video_resp_consent,
                });
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
